<template>
  <section :class="$style.root">
    <div :class="[$style.row, $style.header]">
      <div :class="$style.cells">
        <div
          v-for="column in colums"
          :key="column.id"
          :style="{ width: column.width ? column.width : 'initial' }"
          :class="[
            $style.cell,
            { [$style.grow]: !column.width },
            { [$style.right]: column.right },
          ]"
        >
          <slot
            v-if="column.headerCellSlot"
            :id="column.id"
            name="header-cell"
          />
          <span v-else>
            {{ column.label }}
          </span>
        </div>
      </div>
      <div v-if="$listeners.delete" :class="$style.iconWidth" />
    </div>
    <div
      v-for="(row, index) in data"
      :key="index"
      :class="[
        $style.row,
        { [$style.pointer]: $listeners['row-click'] },
      ]"
      @click="$emit('row-click', row)"
    >
      <div :class="$style.cells">
        <div
          v-for="column in colums"
          :key="column.id"
          :style="{ width: column.width ? column.width : 'initial' }"
          :class="[
            $style.cell,
            { [$style.grow]: !column.width },
            { [$style.right]: column.right },
          ]"
        >
          <slot
            v-if="column.rowCellSlot"
            :columnId="column.id"
            :data="row"
            name="row-cell"
          />
          <span v-else-if="column.getter">
            {{ column.getter(row) }}
          </span>
          <span v-else-if="column.path">
            {{ get(row, column.path) }}
          </span>
        </div>
      </div>
      <div v-if="$listeners.delete">
        <icon
          name="trash"
          button
          @click.stop="$emit('delete', row)"
        />
      </div>
    </div>
  </section>
</template>

<script>
import get from 'lodash/get';
import Icon from '@/ui-kit/Icon';

export default {
  name: 'SimpleTable',
  components: {
    Icon,
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    colums: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    get,
  },

}
</script>

<style lang="scss" module>
@import '_theme/main';

.root {
  color: $text-primary-color;
}

.cells {
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.row {
  display: flex;
  align-items: center;
  min-height: 60px;


  &.header {
    border-bottom: 1px dashed $line-color;
  }

  &.pointer {
    cursor: pointer;

    &:hover:not(.header) {
      background: $bg-accented-color;
      border-radius: $border-radius-block;
    }
  }
}

.cell {
  padding: 0 $gap-s;

  &.right {
    text-align: right;
  }
}

.grow {
  flex-grow: 1;
}

.iconWidth {
  width: 26px;
}

</style>
